module.exports = __webpack_public_path__ + "img/45.1ecf226e.jpg";